import { render, staticRenderFns } from "./permission-auth.vue?vue&type=template&id=163391a6&scoped=true&lang=pug&"
import script from "./permission-auth.vue?vue&type=script&lang=ts&"
export * from "./permission-auth.vue?vue&type=script&lang=ts&"
import style0 from "./permission-auth.vue?vue&type=style&index=0&id=163391a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163391a6",
  null
  
)

export default component.exports